import { html, render } from 'lit-html'
import { signOut } from '../auth.js'
import styles from './signout-link.css'

export class SignOutLink extends HTMLElement {
  shadow: ShadowRoot

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  connectedCallback(): void {
    this.render()
  }

  handleClick(event: Event): void {
    event.preventDefault()
    signOut()
  }

  render(): void {
    const template = html`
      <style>
        ${styles}
      </style>
      <a href="/" @click=${this.handleClick}>Sign out</a>
    `
    render(template, this.shadow, { host: this })
  }
}

customElements.define('signout-link', SignOutLink)
